import { ZIndex } from 'library/constants';
import { NAVBAR_HEIGHT } from 'library/globals';
import { ThemeType } from 'theme/jss-types';

export const navbarStyles = (theme: ThemeType) => ({
    mainDiv: {
        width: '100%',
        height: `${NAVBAR_HEIGHT}px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
        borderBottom: '1px solid #EFEFEF',
        color: 'black',
        backgroundColor: theme.primaryColor,
        position: 'sticky',
        top: 0,
        zIndex: ZIndex.navbar,
    },
    logoBox: {
        fontSize: 32,
        fontWeight: 600,
        height: '100%',
        alignSelf: 'center',
        color: 'pink',
        margin: 'auto 16px',
        display: 'flex',
        alignItems: 'center',
        // width: '40%',
        '& img': {
            maxHeight: 32,
        },
    },
    rightBox: {
        display: 'flex',
        width: '60%',
        alignItems: 'center',
        justifyContent: 'end',
        '& .ant-btn-text': {
            borderRadius: 4,
            '&:hover': {
            },
        },
    },
    trackConsignment: {
        display: 'flex',
        marginRight: 16,
    },
    leftBox: {
        height: '100%',
        display: 'flex',
        width: '60%',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    search: {
        borderRadius: '0 4px 4px 0 !important',
        width: '273px !important',
    },
    searchSelect: {
        margin: '0 !important',
        width: '200px !important',
        '& .ant-btn': {
            borderRadius: 4,
        },
        '& .ant-select-arrow': {
        },
        '& .ant-select-selector': {
            fontWeight: 600,
            fontSize: 12,
            width: 'auto !important',
            borderRadius: '4px 0 0 4px !important',
            alignItems: 'center',
            background: `${theme.secondaryFillColor} !important`,
            borderColor: `${theme.strokeColor} !important`,
        },
        '& .ant-select-dropdown': {
            padding: '12px !important',
            borderRadius: '6px !important',
            gap: '16px !important',
        },
        '& .ant-select-item': {
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
            fontWeight: 600,
        },
        '& .ant-select-item-option-selected': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
        },
    },
    titleBar: {
        borderColor: `${theme.secondaryFillColor} !important`,
        height: 24,
    },
    pageTitle: {
        fontWeight: 600,
        fontSize: 14,
    },
    trackInput: {
        backGroundColor: 'green !important',
        width: '180 !important',
        marginRight: '1%',
    },
    trackDropDown: {
        fontSize: 12,
    },
    inputs: {
        display: 'flex',
        alignItems: 'center',
    },
    input: {
        width: '36%',
        margin: '0 2px',
    },
    profile: {
        height: 32,
        width: 32,
        borderRadius: 16,
        border: `1px solid ${theme.strokeColor}`,
        backgroundColor: theme.secondaryFillColor,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        fontWeight: 'bold',
        justifyContent: 'center',
    },
    username: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 16,
        width: 32,
    },
    img: {
        fontSize: 32,
        marginRight: '4%',
        cursor: 'pointer',
        marginBottom: 6,
        width: '4%',
    },
    modal: {
        position: 'absolute',
        marginLeft: '57%',
        top: NAVBAR_HEIGHT,
        '& .ant-modal-content': {
            padding: 24,
            width: 351,
            borderRadius: '0 0 4px 4px',
            backgroundColor: '#F8F2DE',
        },
        '& .ant-modal-body': {
            padding: 0,
        },
        '& .ant-btn-primary': {
            marginLeft: 2,
            backgroundColor: `${theme.primaryColor} !important`,
            fontSize: 12,
            fontWeight: 600,
            borderRadius: 4,
        },
        '& .ant-input, .ant-input-affix-wrapper': {
            boxSizing: 'border-box',
            border: '1px solid #999999',
            borderRadius: 4,
            marginRight: 2,
        },
    },
    pincode: {
        display: 'flex',
        flexDirection: 'column',
    },
    availabilityTitle: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 16,
        fontWeight: 600,
        letterSpacing: 0,
        marginBottom: 12,
    },
    pincodeText: {
        fontSize: 12,
        marginLeft: '6%',
        fontWeight: 600,
    },
    oldLink: {
        boxSizing: 'border-box',
        maxHeight: '100%',
        color: 'white',
        justifyContent: 'flex-start',
        marginRight: 24,
    },
    rateCalculator: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        color: '#FFFFFF',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        minWidth: 'fit-content',
        textAlign: 'center',
        margin: 12,
    },
    quickAction: {
        marginRight: 16,
        fontWeight: 500,
        fontSize: 12,
        backgroundColor: `${theme.secondaryFillColor} !important`,
        borderColor: `${theme.strokeColor} !important`,
    },
    changeLanguageDropdown: {
        '&.ant-select': {
            width: '100% !important',
        },
        '&.ant-select .ant-select-selector': {
            margin: '0 !important',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            border: 'none !important',
        },
        '& .ant-select-selector': {
            width: '100%',
            padding: '0 !important',
            height: '22px !important',
        },
    },
    walletBalance: {
        backgroundColor: `${theme.secondaryFillColor} !important`,
        borderColor: `${theme.strokeColor} !important`,
        marginRight: 16,
        '& .ant-btn': {
            borderRadius: 4,
        },
    },
    mobileTrackTabs: {
        width: '100%',
        '& .ant-tabs-nav': {
            margin: 0,
        },
        '& .ant-tabs-nav-list': {
            flexGrow: 1,
        },
        '& .ant-tabs-tab': {
            flexGrow: 1,
            margin: 0,
            justifyContent: 'center',
            fontSize: 16,
            fontWeight: 600,
        },
    },
    trackConsignmentMobile: {
        marginBottom: 12,
        '& .ant-input-group-addon': {
            background: 'transparent',
        },
        '& .ant-input': {
            height: 40,
        },
    },
    navbarButton: {
        border: '1px solid #fff',
        borderRadius: 15,
    },
    navbarButtonGroup: {
        display: 'flex',
        gap: 8,
    },
});
